import useSiteMetadata from 'utils/hooks/useSiteMetadata'

const SEO = ({ title, description, children, localeTitle, publicImage }) => {
  const { title: defaultTitle, description: defaultDescription, image, siteUrl } = useSiteMetadata()

  const seo = {
    title: localeTitle || title || defaultTitle,
    description: description || defaultDescription,
    image: `${siteUrl}${publicImage || image}`,
    url: `${siteUrl}${'' || ``}`,
  }

  const metaTags = [
    ['description', seo.description],
    ['image', seo.image],
    ['og:url', seo.url],
    ['og:type', 'article'],
    ['og:title', seo.title],
    ['og:description', seo.description],
    ['og:image', seo.image],
  ]

  return (
    <>
      <title>{seo.title}</title>
      {metaTags.map(([name, content]) => (
        <meta key={name} name={name} content={content} />
      ))}
      {children}
    </>
  )
}

export default SEO
